import ImageEditor from "../Components/ImageEditor/ImageEditor";
import FilesUploadingLayout from "./FilesUploadingLayout";

interface IDragAndDropFileSelectedLayout {
  selectedFiles: any;
  forCrop: boolean;
  setFiles: any;
  handleClose?: () => void;
}

const DragAndDropFileSelectedLayout = (
  props: IDragAndDropFileSelectedLayout
) => {
  const { selectedFiles, forCrop, setFiles, handleClose } = props;

  const handleDeleteFile = (index: number) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
    if (updatedFiles.length === 0) {
      setFiles(null);
    }
  };
  return (
    <>
      {forCrop ? (
        <div>
          <ImageEditor
            selectedFiles={selectedFiles}
            extractCroppedImage={setFiles}
            handleClose={handleClose}
          />
        </div>
      ) : !forCrop ? (
        <div className="dragAndDropLayout p-3">
          <div className="drop-zone p-3 max-height overflow-auto">
            {Array.from(selectedFiles).map((file: any, idx) => {
              return (
                <FilesUploadingLayout
                  filename={file.name}
                  fileExtension={file.name.split(".").pop()}
                  fileSize={file.size}
                  onDelete={() => handleDeleteFile(idx)}
                />
              );
            })}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default DragAndDropFileSelectedLayout;
